export default __webpack_public_path__ + "static/media/Fiercelord Straps.a6a069ac.jpg";